const Privacy = () => {
    return (
        <div className="container my-4">
            <h1 className="mb-4">Privacy Policy</h1>
            <p>
                12157152 CANADA LTD ("PerPal", "we", "us", or "our") is committed to protecting the privacy of
                individuals who interact with software platforms operated by our Clients. This Privacy Policy
                outlines how we collect, use, disclose, and safeguard your information when you access a service
                or website built and powered by the PerPal Platform (the “Services”).
            </p>

            <section>
                <h2>1. Definition of Personal Information</h2>
                <p>
                    “Personal Information” means information about an identifiable individual, excluding business
                    contact information. This includes but is not limited to your name, contact details,
                    government-issued ID, financial details, and IP address.
                </p>
            </section>

            <section>
                <h2>2. Legal Basis and Consent</h2>
                <p>
                    By accessing or using the Services, or submitting Personal Information to us or to the Client
                    operating the service you’re using, you consent to the collection, use, disclosure, and processing
                    of your Personal Information as described in this Privacy Policy. We handle such data in accordance
                    with applicable Canadian privacy laws, including the Personal Information Protection and Electronic
                    Documents Act (PIPEDA).
                </p>
            </section>

            <section>
                <h2>3. Information We Collect</h2>
                <h3>3.1 Information You Provide</h3>
                <ul>
                    <li>Name, address, email, phone number</li>
                    <li>Financial and payment information</li>
                    <li>Identity verification documents</li>
                    <li>Profile information (as required by the Client)</li>
                </ul>

                <h3>3.2 Technical Information</h3>
                <ul>
                    <li>IP address, device and browser type</li>
                    <li>Operating system and time zone</li>
                    <li>Page visit data, navigation patterns, and activity logs</li>
                </ul>

                <h3>3.3 Information from Third Parties</h3>
                <ul>
                    <li>Identity or transaction verification from banks or service providers</li>
                    <li>Login data from social media accounts if used for authentication</li>
                    <li>Compliance checks from third-party identity verification tools</li>
                </ul>
            </section>

            <section>
                <h2>4. Use of Cookies and Tracking Technologies</h2>
                <p>
                    We and our Clients may use cookies, pixels, and analytics tools to:
                </p>
                <ul>
                    <li>Ensure functionality and security of the platform</li>
                    <li>Personalize and enhance user experience</li>
                    <li>Analyze service usage for improvement</li>
                </ul>
                <p>
                    Users can manage cookies via browser settings. Restricting cookies may impact service functionality.
                </p>
            </section>

            <section>
                <h2>5. Use of Personal Information</h2>
                <p>
                    Personal Information may be used by the Client and/or us to:
                </p>
                <ul>
                    <li>Provide the service requested</li>
                    <li>Verify identity (KYC/AML)</li>
                    <li>Prevent fraud and ensure security</li>
                    <li>Improve the platform and user experience</li>
                    <li>Send service-related communications</li>
                </ul>
                <p>
                    PerPal may also process data to fulfill contractual support obligations to our Clients.
                </p>
            </section>

            <section>
                <h2>6. Disclosure of Personal Information</h2>
                <p>
                    Your Personal Information may be disclosed to:
                </p>
                <ul>
                    <li><strong>Clients:</strong> The service provider (Client) you signed up with has full control over
                        your account and personal data within their service instance.
                    </li>
                    <li><strong>Service Providers:</strong> Identity verification vendors, infrastructure hosting
                        providers,
                        and analytics services
                    </li>
                    <li><strong>Regulatory or Legal Authorities:</strong> In response to lawful requests, including by
                        FINTRAC or other regulators
                    </li>
                    <li><strong>Business Transactions:</strong> If PerPal undergoes a sale, merger, or restructuring
                    </li>
                </ul>
                <p>
                    PerPal does not control or assume liability for how individual Clients use or disclose data beyond
                    their responsibilities under our platform agreement.
                </p>
            </section>

            <section>
                <h2>7. Data Retention</h2>
                <p>
                    We and our Clients retain Personal Information only for as long as necessary to fulfill legal,
                    operational, or contractual obligations, including KYC/AML recordkeeping.
                </p>
            </section>

            <section>
                <h2>8. Security</h2>
                <p>
                    We maintain robust technical, organizational, and physical safeguards to protect Personal
                    Information,
                    including:
                </p>
                <ul>
                    <li>Encrypted communication and data storage</li>
                    <li>Role-based access controls</li>
                    <li>Regular monitoring and auditing</li>
                </ul>
                <p>
                    While we work to secure your data, no digital system is completely immune to threats.
                </p>
            </section>

            <section>
                <h2>9. Cross-Border Transfers</h2>
                <p>
                    Data may be stored or processed outside of Canada, including in the United States. We take
                    reasonable
                    measures to ensure comparable levels of protection in those jurisdictions.
                </p>
            </section>

            <section>
                <h2>10. Your Rights</h2>
                <p>
                    You have the right to:
                </p>
                <ul>
                    <li>Access the Personal Information held about you</li>
                    <li>Correct or update inaccurate information</li>
                    <li>Withdraw your consent, subject to legal limitations</li>
                </ul>
                <p>
                    Please contact your service provider (the Client) to exercise these rights. PerPal may assist in
                    support roles where applicable.
                </p>
            </section>

            <section>
                <h2>11. Use of Services by Minors</h2>
                <p>
                    Services provided through the PerPal Platform are not intended for individuals under 18. We do not
                    knowingly collect data from minors.
                </p>
            </section>

            <section>
                <h2>12. Third-Party Links and Tools</h2>
                <p>
                    Our platform may contain links to third-party sites or embed third-party tools. We are not
                    responsible
                    for their privacy practices. Users should review those sites' privacy policies separately.
                </p>
            </section>

            <section>
                <h2>13. Changes to this Policy</h2>
                <p>
                    We may revise this Privacy Policy from time to time. The “Last Updated” date reflects the most
                    recent version. Use of the Services after changes constitutes acceptance of the updated policy.
                </p>
            </section>

            <section>
                <h2>14. Contact</h2>
                <p>
                    If you have questions or concerns regarding this Privacy Policy as it applies to the PerPal
                    Platform,
                    contact us at:
                </p>
                <p>
                    12157152 CANADA LTD (PerPal)<br/>
                    Email: <a href="mailto:info@perpal.io">info@perpal.io</a><br/>
                    Please do not send sensitive information by email.
                </p>
                <p>
                    For questions about your account, transactions, or personal data handling, please contact your
                    service
                    provider (Client) directly through their official support channels.
                </p>
            </section>
        </div>
    );
};

export default Privacy;